export default "__VITE_ASSET__BKza6x$P__"